import React, { useMemo, useState } from "react"
import PropTypes from "prop-types"
import { Select, Space } from "antd"
import { useOutletContext } from "react-router-dom"

import { useAppContext } from "@components/AppContext"
import { getActiveProjects } from "@components/Project"

import listProjectInvestments from "./helpers/listProjectInvestments"
import { listProjectBatches } from "./helpers/listProjectFiles"

const LABEL_TRANSFER_TO = "Transfer to"
const LABEL_PLACEHOLDER = "Select a project"


const TargetProjectSelect = ({
  targetProjectId = undefined,
  sourceProjectId = undefined,
  setTargetBatches,
  setTargetProjectId,
  setTargetInvestments,
}) => {
  const [ isLoading, setIsLoading ] = useState(false)

  const { request } = useAppContext()
  const { projects } = useOutletContext()

  const targetProjectOptions = useMemo(() =>
    getActiveProjects(projects)
      .filter(({ id }) => id !== sourceProjectId)
      .map(({ id, name }) => ({ label: name, value: id }))
  , [ projects, sourceProjectId ])

  const onChange = async (projectId) => {
    if (!projectId) {
      setTargetProjectId()
      setTargetInvestments([])
      return
    }

    setIsLoading(true)

    const investmentsPromise = listProjectInvestments(request, projectId)
      .then(investments => setTargetInvestments(investments))

    const batchesPromise = listProjectBatches(request, projectId)
      .then(batch => setTargetBatches(batch))

    await Promise.all([
      batchesPromise,
      investmentsPromise,
    ])

    setIsLoading(false)
    setTargetProjectId(projectId)
  }

  return (
    <Space>
      <span>
        {LABEL_TRANSFER_TO}:
      </span>

      <Select
        showSearch
        allowClear
        value={targetProjectId}
        options={targetProjectOptions}
        onChange={onChange}
        placeholder={LABEL_PLACEHOLDER}
        optionFilterProp="label"
        loading={isLoading}
        disabled={isLoading}
      />
    </Space>
  )
}

TargetProjectSelect.propTypes = {
  sourceProjectId: PropTypes.string,
  targetProjectId: PropTypes.string,
  setTargetBatches: PropTypes.func.isRequired,
  setTargetProjectId: PropTypes.func.isRequired,
  setTargetInvestments: PropTypes.func.isRequired,
}

export default TargetProjectSelect
